//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return{
      categoriesCounter:3,
      isShow:true,
    }
  },
  emits:['close'],
  props: {
    content:{
      type:Array,
      required:true,
      default(){
        return [];
      }
    },
    activeCategory:{
      type:String,
      reuqired: false,
      default(){
        return '';
      }
    }
  },
  computed:{
    getCategoriesCounter(){
      if(this.activeCategory === '3'){
          return this.content.length ;
        }
        return this.categoriesCounter;
    }
  },
  methods: {
    // Костыль для ссылки если подарочный сертификат
    getCategoryUrl(category) {
      if (category.slug === 'podarochnye-sertifikaty') {
        return '/sertifikaty';
      } else {
        return category.url
      }
    }
  }
};
